<template>
    <rkm-area
        no-margin-top
        :title="title ? title : 'Antropometria'"
    >
        <rkm-row>
            <rkm-col>
                <Item
                    :get-value="() => data.peso"
                    append-text="kg"
                    label="Peso"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => data.altura"
                    append-text="cm"
                    label="Altura"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => data.imc.imc"
                    append-text="Kg/m²"
                    label="IMC"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => data.perimetroCefalico"
                    append-text="cm"
                    label="Perímetro cefálico"
                />
            </rkm-col>

            <rkm-col cols="3">
                <Item
                    :get-value="() => data.circunferenciaAbdominal"
                    append-text="cm"
                    label="Circunferência abdominal"
                />
            </rkm-col>

            <rkm-col cols="3">
                <Item
                    :get-value="() => data.perimetroPanturrilha"
                    append-text="cm"
                    label="Perímetro da panturrilha"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        data: {type: Object},
        title: {type: String, default: null},
    },
}
</script>